import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios";
import { URLS } from "constants/api.constants";

export const registerUser = createAsyncThunk('auth/register', async (params, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.AUTH.REGISTER, params);
        if (response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
})

export const loginUser = createAsyncThunk('auth/login', async (params, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.AUTH.LOGIN, params);
        if (response.data?.requires_verification) {
            return thunkAPI.rejectWithValue({
              requires_verification: true,
              message: response.data.message,
              email: response.data.email,
            });
          }
        if (response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
})

export const logoutUser = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
    try {
        const response = await axiosInstance.get(URLS.AUTH.LOGOUT);
        localStorage.clear()
        if (response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
})

// Fix for the forgotPassword thunk
export const forgotPassword = createAsyncThunk('auth/forgot-password', async (params, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.AUTH.FORGOT_PASSWORD, params);
        if (response.data?.success) return response.data;
        else return thunkAPI.rejectWithValue(response.data?.message); // Added return here
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
  });
  
  export const verifyOtp = createAsyncThunk('auth/verify-otp', async (params, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.AUTH.VERIFY_OTP, params);
        if (response.data?.success) return response.data;
        else return thunkAPI.rejectWithValue(response.data?.message); // Added return here
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
  });

export const resetPassword = createAsyncThunk('auth/reset-password', async (params, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.AUTH.RESET_PASSWORD, params);
        if (response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message);
    }
})

export const signupOtp = createAsyncThunk('auth/signup-otp', async (params, thunkAPI) => {
    try{
        const response = await axiosInstance.post(URLS.AUTH.SIGNUP_OTP, params);
        if (response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    }catch(error){
        return thunkAPI.rejectWithValue(error?.message);
    }
})


export const resendOtp = createAsyncThunk('auth/resend-otp', async (params, thunkAPI) => {
    try{
        const response = await axiosInstance.post(URLS.AUTH.RESEND_OTP, params);
        if(response.data?.success) return response.data
        else thunkAPI.rejectWithValue(response.data?.message)
    }catch(error){
        return thunkAPI.rejectWithValue(error?.message);
    }
    
})